"use strict";

class DeveloperEmailsController {

  constructor($scope, $window, $filter, SSAppService, SSHttpService, SSUtilService, SSDateService, SSAlertService, $timeout, SSConfigService, NgTableParams, SSConfirmationService, SSUserService, SSAnalyticsService) {
    const self = this;

    self.$scope = $scope;
    self.$window = $window;
    self.SSAppService = SSAppService;
    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSDateService = SSDateService;
    self.SSAlertService = SSAlertService;
    self.SSUserService = SSUserService;
    self.$timeout = $timeout;
    self.SSConfigService = SSConfigService;
    self.SSConfirmationService = SSConfirmationService;
    self.SSAnalyticsService = SSAnalyticsService;
    self.data = SHOWSUITE.data;
    self.filter = $filter;
    self.NgTableParams = NgTableParams;

    self.EMAIL_LOG_ROLE_BUYER = SHOWSUITE.EMAIL_LOG_ROLE_BUYER;
    self.EMAIL_LOG_ROLE_LAWYER = SHOWSUITE.EMAIL_LOG_ROLE_LAWYER;
    self.EMAIL_LOG_ROLE_BROKER = SHOWSUITE.EMAIL_LOG_ROLE_BROKER;
    self.EMAIL_LOG_ROLE_DEVELOPER = SHOWSUITE.EMAIL_LOG_ROLE_DEVELOPER;
    self.EMAIL_LOG_ROLE_TEAMIC = SHOWSUITE.EMAIL_LOG_ROLE_TEAMIC;
    self.EMAIL_LOG_ROLE_DEVELOPER_LAWYER = SHOWSUITE.EMAIL_LOG_ROLE_DEVELOPER_LAWYER;

    if (self.SSUserService.isDeveloper()) {
        self.init();
    }
  }

  init() {
    const self = this;

    // Trigger View Event for Emails Page
    self.SSAnalyticsService.saveAnalyticEvent({
          event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_EMAILS,
          user_id: self.SSUtilService.getFromLocalStorage('user').id
        }
    );

    self.offset = 0;
    self.limit = 10;
    self.current = 1;
    self.total_emails = 0;

    self.pagination = {
      current: 1
    };

    self.pageChanged = function(newPage) {
      self.getEmailLogs(newPage);
    };

    self.emails = null;
    self.getEmailLogs();
  }

  getEmailLogs(page) {
    const self = this;

    self.$timeout(function () {
      jQuery('.datepicker').datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "1900:+0",
        dateFormat: "yy-mm-dd"
      });
    });

    if(page) {
      self.offset = (page * self.limit) - self.limit;
      self.current = page;
    }

    let url = 'sec/email-logs';
    let params = {
      offset: self.offset,
      limit: self.limit,
      send_total_count: true,
      search:self.search,
      from_date:self.from_date,
      to_date:self.to_date
    };

    loading(true);
    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
      loading(false);
      if (response instanceof Error) {
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }
      if(response.data && response.data.email_status_logs){
        self.emails = response.data.email_status_logs;
        self.total_emails = response.data.count;
      }

    });
  }

  reset(){
    const self = this;
    self.search = '';
    self.to_date = '';
    self.from_date = '';
    self.getEmailLogs();
  }

  previousPage() {
    const self = this;

    self.offset = self.offset - parseInt(self.limit);
    self.getEmailLogs();
  }

  nextPage() {
    const self = this;

    self.offset = self.offset + parseInt(self.limit);
    self.getEmailLogs();
  }

  updateFilter() {
    const self = this;

    self.offset = 0;
    self.getEmailLogs();
  }

  getEmailReceiverRole(role_id){
    const self = this;

    if(role_id == self.EMAIL_LOG_ROLE_BUYER){
      return 'Buyer';
    }
    else if(role_id == self.EMAIL_LOG_ROLE_LAWYER){
      return 'Lawyer';
    }
    else if(role_id == self.EMAIL_LOG_ROLE_BROKER){
      return 'Broker';
    }
    else if(role_id == self.EMAIL_LOG_ROLE_DEVELOPER){
      return 'Developer';
    }
    else if(role_id == self.EMAIL_LOG_ROLE_TEAMIC){
      return 'Team IC';
    }
    else if(role_id == self.EMAIL_LOG_ROLE_DEVELOPER_LAWYER){
      return 'Developer Lawyer';
    }
  }

  getFormattedDateTime(date_time){
    const self = this;

    if(!date_time){
      return '--';
    }
    else{
      return self.SSUtilService.formatUtcToLocalDate(date_time) + " " + self.SSUtilService.formatUtcToLocalTime(date_time);
    }
  }

  getEmailAddresses(email_ids){
    const self = this;

    let email_addresses = '--';

    if(!email_ids){
      return email_addresses;
    }
    else{
      let email_array = email_ids.split(',');
      email_addresses = email_array[0];

      if(email_array.length > 1){
        $.each(email_array, function(index, email){
          email_addresses += '\n ' + email;
        });
      }

      return email_addresses;
    }
  }

}

DeveloperEmailsController.$inject = ['$scope', '$window', '$filter', 'SSAppService', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAlertService', '$timeout', 'SSConfigService', 'NgTableParams', 'SSConfirmationService', 'SSUserService', 'SSAnalyticsService'];
app.controller('DeveloperEmailsController', DeveloperEmailsController);






